import React from 'react';
import { Route } from 'react-router-dom';

import UnderConstruction from 'shared/ui/UnderConstruction';
import EditClient from 'features/parties/pages/EditClient';
import Shifts from 'features/pos/pages/shifts/Shifts';

export const posRoutes = (
  <Route path='pos'>
    <Route index element={<UnderConstruction />} />
    <Route path='shifts' element={<Shifts />} />

    <Route path='edit-client' element={<EditClient />} />
  </Route>
);

export const posTitles = [
  { path: '/pos/shifts', title: 'Смены POS' },
  { path: '/pos/edit-client', title: 'Редактирование клиента' },
  { path: '/pos', title: 'POS' },
];
